module.exports = "0056d795fa65f1bcf861452759ae9324.png";


//////////////////
// WEBPACK FOOTER
// ./assets/sprites/star2.png
// module id = 75
// module chunks = 0